var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmsCorporateService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.1644 32.3984H21.7339V32.4822H24.1644V32.3984Z",
    fill: "#76BC21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19.4041 22.1602H16.9736V22.244H19.4041V22.1602Z",
    fill: "#76BC21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5367 11.1117H21.0633M10.5367 15.9894H21.0633M37.0376 18.8892V35.4669L34.7077 34.193L31.5899 32.5H18.13C16.0347 32.5 14.3417 30.8071 14.3417 28.7118V22.2584H23.2592C24.2146 22.2584 25.0695 21.8729 25.7064 21.2527C26.3769 20.6157 26.7792 19.7273 26.7792 18.7384V15.1178H33.2494C35.3446 15.1178 37.0376 16.8107 37.0376 18.8892ZM26.796 6.11653V18.4534C26.796 20.5487 25.103 22.2417 23.0077 22.2417H9.54778L4.1001 25.2085V8.6476C4.1001 6.55235 5.79307 4.85938 7.88833 4.85938H25.5388C26.2428 4.85938 26.796 5.42929 26.796 6.11653Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsCorporateService);
export default __webpack_public_path__ + "static/media/smsCorporateService.90dda4f1426470fad98044a2d5b7df4c.svg";
export { ForwardRef as ReactComponent };